
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { getProductInfo } from '@/api/product/productAccount'

@Component({
  name: 'indiaQrExtra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    paytm: '',
    is_filter_abnormal: 1,
    filter_abnormal_time: null,
    order_max_time: 1800,
    not_display_qrcode: [],
    app_not_display_qrcode: false,
    jump_checkout_counter_mode: '',
    floating_amount: null
  }
  private accountType: any = []
  private notDisplayQrcodeArr: any = []
  private appNotDisplayQrcode: boolean = false

  // 收银台比率数据展示
  private serverModeList: any = []
  private onData() {
    if (
      !this.product.checkout_counter_rate.server &&
      !this.product.checkout_counter_rate.oss
    ) {
      this.serverModeList = [
        {
          name: 'server',
          rate: '',
          success_volume: '',
          time: '',
          volume: ''
        },
        {
          name: 'oss',
          rate: '',
          success_volume: '',
          time: '',
          volume: ''
        }
      ]
    } else {
      this.serverModeList = [
        {
          name: 'server',
          rate: this.product.checkout_counter_rate.server.rate,
          success_volume:
            this.product.checkout_counter_rate.server.success_volume,
          time: this.product.checkout_counter_rate.server.time,
          volume: this.product.checkout_counter_rate.server.volume
        },
        {
          name: 'oss',
          rate: this.product.checkout_counter_rate.oss.rate,
          success_volume: this.product.checkout_counter_rate.oss.success_volume,
          time: this.product.checkout_counter_rate.oss.time,
          volume: this.product.checkout_counter_rate.oss.volume
        }
      ]
    }
  }

  private addMc() {
    this.extraParam.not_display_qrcode.push('')
  }

  private removeMc(index: number) {
    this.extraParam.not_display_qrcode.splice(index, 1)
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private abnormalTime: any = Math.round(new Date().getTime() / 1000)
  private change(e) {
    if (e === 1) {
      this.extraParam.filter_abnormal_time = this.abnormalTime
    } else {
    }
    if (e === 0) {
      this.extraParam.filter_abnormal_time = this.abnormalTime
    }
  }

  private async extraUpdate() {
    const data: any = {
      id: this.product.id,
      extra_param: {
        paytm: {
          is_filter_abnormal: this.extraParam.is_filter_abnormal,
          filter_abnormal_time: Number(this.extraParam.filter_abnormal_time),
          order_max_time: Number(this.extraParam.order_max_time)
        }
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.back()
    })
  }

  // 跳转收银台模式
  private exists: any = ''
  private async checkoutCounterMode() {
    this.exists = this.extraParam.jump_checkout_counter_mode
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        jump_checkout_counter_mode: this.exists
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 不显示二维码商户号
  private async noDataNotDisplayQrcode() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        not_display_qrcode: this.extraParam.not_display_qrcode
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 不显示应用二维码
  private async noAppDataNotDisplayQrcode() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        app_not_display_qrcode: this.extraParam.app_not_display_qrcode
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 金额浮动下限
  private async setFloatingAmount() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        floating_amount: Number(this.extraParam.floating_amount)
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      console.log('执行了')
      console.log(res, 'res')
      if (res) {
        this.extraParam = {
          paytm: this.accountType[0],
          is_filter_abnormal: res.extra_param.paytm.is_filter_abnormal,
          filter_abnormal_time: res.extra_param.paytm.filter_abnormal_time,
          order_max_time: res.extra_param.paytm.order_max_time,
          not_display_qrcode: res.extra_param.not_display_qrcode,
          app_not_display_qrcode: res.extra_param.app_not_display_qrcode,
          jump_checkout_counter_mode:
            res.extra_param.jump_checkout_counter_mode,
          floating_amount: res.extra_param.floating_amount
        }
      } else {
        this.extraParam = {
          paytm: '',
          is_filter_abnormal: 1,
          filter_abnormal_time: this.abnormalTime,
          order_max_time: 1800,
          not_display_qrcode: [],
          app_not_display_qrcode: false,
          jump_checkout_counter_mode: '',
          floating_amount: null
        }
      }
    })
  }

  mounted() {
    this.accountType = []
    for (let key in this.product.product_account_param) {
      this.accountType.push(key)
    }
    this.onData()
    this.getInfo()
  }
}
